<template>
  <div id="container">
    <!-------------- 备货信息 -------------->
    <distribution-information
      :stockInformation="stockInformation"
      ref="distributionInformastionRefs"
    ></distribution-information>
    <!--------------- 待配货清单 ------------------>
    <wait-distribution-list
      :allocatedList="allocatedList"
      @detailDrawer="detailDrawer"
      @onMovedIntoWarehouse="onMovedIntoWarehouse"
      @onMovedIntoPurchase="onMovedAllot"
      @onMovedIntoPurchaseAll="onMovedIntoPurchaseAll"
      ref="waitDistributionListRefs"
    ></wait-distribution-list>
    <div class="item-box-content">
      <div class="title-font-style">
        <span>配货方案</span>
      </div>
      <!--------------- 仓库备货区 ------------------>
      <warehouse-stock-up
        :listStockUp="warehouseList"
        @returnWarehouse="returnWarehouse"
        ref="warehouseStockUpRefs"
      ></warehouse-stock-up>
      <!--------------- 采购备货区 ------------------>
      <purchase-list
        :listStockUp="purchaseList"
        @returnPurchaseList="purchasePlan"
        ref="purchaseListRefs"
      ></purchase-list>
    </div>
    <el-button @click="onSubmitStockUp" type="primary">提交备货</el-button>
    <!-------------- 库存详情查看 -------------->
    <distribution-inventory-details-drawer
      ref="distributionInventoryDetailsDrawerRefs"
      @payableDrawer="payableDrawer"
    ></distribution-inventory-details-drawer>
  </div>
</template>
<script>
import distributionInformation from './distributionInformation' // 基本信息
import waitDistributionList from './waitDistributionList' // 待备货清单
import warehouseStockUp from './warehouseStockUp' // 仓库备货区
import purchaseList from './purchaseList' // 仓库备货区
import distributionInventoryDetailsDrawer from '../../dialog/distributionInventoryDetailsDrawer' // 货架详情Drawer
import { formatDate } from '@/util/tool' // 时间格式化
import { deepClone } from '@/util' // 深Clone
import { queryOrderContractStockupAllVo, addOrderContractStockupPurchase } from '@/api/purchase/waitAllocateCargolist'
export default {
  components: {
    'purchase-list': purchaseList, // 采购备货区
    'distribution-information': distributionInformation, // 基本信息
    'wait-distribution-list': waitDistributionList, // 待备货清单
    'distribution-inventory-details-drawer': distributionInventoryDetailsDrawer, // 货架详情Drawer
    'warehouse-stock-up': warehouseStockUp // 仓库备货区
  },
  data () {
    return {
      status: 1,
      procurementPlanListClone: [{ orderContractStockupVoList: [] }], // 采购备货区的数据Clone
      purchaseList: [{ orderContractStockupVoList: [] }], // 采购备货区的数据
      bigArray: {}, // 总数据
      stockInformation: {}, // 备货的基本信息
      allocatedList: [], // 待配货清单数据
      allocatedListClone: [], // 待配货清单数据Clone
      allocatedListUsed: [], // 待配货清单数据Used
      warehouseList: [], // 仓库备货区
      cbPriceSource: ['系统', '人工', '特价审批', '其他'] // 询价来源
    }
  },
  mounted () {
    // 请求待备货数据
    this.getList()
  },
  methods: {
    returnPurchaseList () {

    },
    // 全部采购备货
    onMovedIntoPurchaseAll (val) {
      this.onMovedIntoWarehouse(val)
    },
    // 批量库存备货
    onMovedIntoWarehouse (row) {
      row.forEach((ele) => {
        this.allocatedListUsed.forEach((element) => {
          if (
            element.orderContractStockupVo.ocscId ===
            ele.orderContractStockupVo.ocscId
          ) {
            if (
              element.localCount ===
              element.orderContractStockupVo.countUsedLocal
            ) {
              this.onMovedAllot([ele])
            } else if (
              element.localCount -
              element.orderContractStockupVo.countUsedLocal <
              (element.orderContractStockupVo.countAll -
                element.orderContractStockupVo.countUsed -
                element.orderContractStockupVo.countUsedAllot)
            ) { // 这是仓库库存不足的情况(本地库存减去本地已用的=还可以备货的)
              const _data = element.localCount - element.orderContractStockupVo.countUsedLocal// 这个是库存还剩下

              const count = element.orderContractStockupVo.countAll - element.orderContractStockupVo.countUsed -
                element.orderContractStockupVo.countUsedAllot - _data// 这个是要此次分配

              const params = deepClone(element.orderContractStockupVo)
              params.count = count
              element.orderContractStockupShelveListVo.orderContractStockupShelvesVos.forEach(eles => { // 遍历自己仓库的数组
                eles.countUsed = eles.countMax
              })
              element.orderContractStockupVo.countUsed += _data
              element.orderContractStockupVo.countUsedAllot =
                element.orderContractStockupVo.countAll - element.orderContractStockupVo.countUsed
              this.formattingAllotClone(count, params) // 把采购计划数据放入Clone数组
              this.PlanReset(count, params) // 分情况采购计划

              this.formattingWaitList() // 调用格式化待配货数据
              this.formattingUsedList() // 使用过得数组
              this.formattingLocalList()
            } else { // 仓库充足的时候
              // 这个情况还没好

              let count = element.orderContractStockupVo.countAll -
                element.orderContractStockupVo.countUsed -
                element.orderContractStockupVo.countUsedAllot// 这个是要此次分配
              element.orderContractStockupVo.countUsed += (element.orderContractStockupVo.countAll -
                element.orderContractStockupVo.countUsed - element.orderContractStockupVo.countUsedAllot)
              const paramsList = element.orderContractStockupShelveListVo.orderContractStockupShelvesVos
              let isFalse = false
              paramsList.forEach(datas => {
                if (!isFalse) {
                  if (datas.countMax - datas.countUsed < count) {
                    count = count - (datas.countMax - datas.countUsed)
                    datas.countUsed = datas.countMax
                  } else {
                    isFalse = true
                    datas.countUsed += count
                  }
                }
              })

              this.formattingUsedList() // 使用过得数组
              this.formattingWaitList() // 调用格式化待配货数据
              this.formattingLocalList()
            }
          }
        })
      })
    },
    // 仓库备货区的撤回
    returnWarehouse (row) {
      this.allocatedListUsed.forEach((element) => {
        if (element.orderContractStockupVo.ocscId === row.ocscId) {
          element.orderContractStockupVo.countUsed =
            element.orderContractStockupVo.countUsed - row.lockCount
          const params =
            element.orderContractStockupShelveListVo
              .orderContractStockupShelvesVos // 仓库的
          const paramsAllot =
            element.orderContractStockupShelveListVo
              .orderContractStockupShelvesVoList // 调拨的
          if (row.distributionType === 1) {
            element.orderContractStockupVo.countUsedLocal = 0
            params.forEach((ele) => {
              ele.countUsed = 0
            })
          } else if (row.distributionType === 2) {
            paramsAllot.forEach((ele) => {
              if (row.storageName === ele.storageName) {
                ele.countUsed = 0
              }
            })
          }
        }
      })
      this.formattingWaitList()
      this.formattingUsedList()
    },
    // 采购配货按钮,批量采购
    onMovedAllot (val) {
      val.forEach((element) => {
        const params = deepClone(element.orderContractStockupVo) // Clone
        params.count =
          params.countAll - params.countUsed - params.countUsedAllot
        this.allocatedListUsed.forEach((ele) => {
          if (ele.orderContractStockupVo.ocscId === params.ocscId) {
            ele.orderContractStockupVo.countUsedAllot =
              params.countAll - params.countUsed
          }
        })
        this.formattingAllotClone(params.count, params) // 把采购计划数据放入Clone数组
        this.PlanReset(params.count, params) // 分情况采购计划
      })
      this.formattingWaitList() // 调用格式化待配货数据
    },
    // 格式化待配货数据,待配货的现有数据
    formattingWaitList () {
      const params = deepClone(this.allocatedListUsed)
      this.allocatedList = []
      params.forEach((element) => {
        const count =
          element.orderContractStockupVo.countAll -
          element.orderContractStockupVo.countUsed -
          element.orderContractStockupVo.countUsedAllot
        if (count !== 0) {
          this.allocatedList.push(element)
        }
      })
    },

    // 格式化仓库备货
    formattingLocalList () {
      this.warehouseList = []
      const params = deepClone(this.allocatedListUsed) // 克隆一份
      params.forEach((element) => {
        if (element.orderContractStockupVo.countUsed !== 0) {
          // 仓库+调拨数量不等于零执行
          if (element.orderContractStockupVo.countUsedLocal > 0) {
            // 自己仓库不为零时
            const param = deepClone(element.orderContractStockupVo)
            param.distributionType = 1
            param.lockCount = element.orderContractStockupVo.countUsedLocal
            param.orderContractStockupShelvesVoList = element.localList
            param.storageName = element.localList[0].storageName
            this.warehouseList.push(param)
          }
          if (
            element.orderContractStockupVo.countUsedLocal !==
            element.orderContractStockupVo.countUsed
          ) {
            // 存在调拨的情况
            element.allotList.forEach((data) => {
              if (data.countUsed !== 0) {
                const param = deepClone(element.orderContractStockupVo)
                param.distributionType = 2
                param.lockCount = data.countUsed
                param.orderContractStockupShelvesVoList = data.dataList
                param.storageName = data.storageName
                this.warehouseList.push(param)
              }
            })
          }
        }
      })
    },
    // 格式化Used使用的小数组数据
    formattingUsedList () {
      this.allocatedListUsed.forEach((element) => {
        element.localList = [] // 每条数据的重要信息的本地仓库
        element.allotList = [] // 每条数据的重要信息的调拨仓库
        const localRepository =
          element.orderContractStockupShelveListVo
            .orderContractStockupShelvesVos // 本地仓库list
        const allotRepository =
          element.orderContractStockupShelveListVo
            .orderContractStockupShelvesVoList // 调拨仓库list
        localRepository.forEach((local) => {
          element.localList.push(local)
        })
        element.orderContractStockupVo.countUsedLocal = 0
        element.localList.forEach((params) => {
          element.orderContractStockupVo.countUsedLocal += params.countUsed
        })
        element.warehouse.forEach((warehouse) => {
          element.allotList.push({
            storageName: warehouse,
            dataList: [],
            countUsed: 0,
            countAll: 0
          })
        })
        element.allotList.forEach((allot) => {
          // // 调拨仓库的数据小数组

          allotRepository.forEach((allotList) => {
            if (allot.storageName === allotList.storageName) {
              allot.dataList.push(allotList)
            }
          })
          allot.dataList.forEach((data) => {
            allot.countAll += data.countMax
            allot.countUsed += data.countUsed
          })
        })
      })
      this.formattingLocalList()
    },
    // 请求数据备货数据
    getList () {
      queryOrderContractStockupAllVo(
        this.$route.query.psbId
      )
        .then((res) => {
          if (res.data.code === 200) {
            this.stockInformation = res.data.obj.orderContractStockup // 备货的基本信息
            this.allocatedList =
              res.data.obj.orderContractStockupAndShelvesVoList // countAll
            // 在数据中添加备货总数countMax、添加仓库
            this.allocatedList.forEach((element) => {
              let localCount = 0
              element.orderContractStockupVo.countUsedLocal = 0
              element.warehouse = [] // 调拨仓库名称
              element.localList = [] // 每条数据的重要信息的本地仓库
              // element.allotList = []// 每条数据的重要信息的调拨仓库
              element.orderContractStockupVo.countAll =
                element.orderContractStockupVo.count // 待配货清单备货总数copy
              element.orderContractStockupVo.countUsed = 0 // 待配货清单备货仓库使用总数copy
              element.orderContractStockupVo.countUsedAllot = 0 // 待配货清单采购copy
              element.orderContractStockupVo.stockNumAll =
                element.orderContractStockupVo.stockNum // 待配货清单在库可备货总数copy
              const localRepository =
                element.orderContractStockupShelveListVo
                  .orderContractStockupShelvesVos // 本地仓库list
              const allotRepository =
                element.orderContractStockupShelveListVo
                  .orderContractStockupShelvesVoList // 调拨仓库list
              localRepository.forEach((local) => {
                local.countMax = +local.counts // 在本地仓库添加最大备货数量
                localCount += +local.counts
                local.countUsed = 0 // 已用过的count
              })
              element.localCount = localCount // 为每条数据加上仓库可备货总数
              allotRepository.forEach((allot) => {
                allot.countMax = allot.counts // 在调拨仓库添加最大备货数量
                allot.countUsed = 0 // 已用过的count
                element.warehouse.push(allot.storageName) // 把所有调拨仓库的仓库名push进去
              })
              element.warehouse = Array.from(new Set(element.warehouse)) // 调拨仓库名字去重最后数组
            })
            this.allocatedListClone = deepClone(this.allocatedList) // 深Clone使用的list
            this.allocatedListUsed = deepClone(this.allocatedList) // 深Clone使用的list
            this.formattingUsedList()
          } else {
            this.$message.error(res.data.msg)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    // 设置头部背景色
    tableHeader ({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    },
    // 打开右侧栏
    detailDrawer (row, index) {
      this.$refs.distributionInventoryDetailsDrawerRefs.onInitial(row, index)
    },
    // 格式化采购计划数据Clone
    formattingAllotClone (count, params) {
      let isFalse = false
      this.procurementPlanListClone[0].orderContractStockupVoList.forEach(
        (ele) => {
          if (params.ocscId === ele.ocscId) {
            isFalse = true
            ele.count += params.count
          }
        }
      )
      if (!isFalse) {
        this.procurementPlanListClone[0].orderContractStockupVoList.push(
          params
        )
      }
    },

    // 库存详情@函数
    payableDrawer (val, index, count) {
      const countAllot =
        this.allocatedList[index].orderContractStockupVo.countAll -
        (this.allocatedList[index].orderContractStockupVo.countUsed +
          count +
          this.allocatedList[index].orderContractStockupVo.countUsedAllot) // 都采购的数量

      const params = deepClone(val.orderContractStockupVo) // Clone
      params.count = countAllot

      this.allocatedListUsed.forEach((element) => {
        // 处理used
        if (
          element.orderContractStockupVo.ocscId ===
          val.orderContractStockupVo.ocscId
        ) {
          const _data =
            element.orderContractStockupShelveListVo
              .orderContractStockupShelvesVos // 本地仓库
          const _dataVal =
            val.orderContractStockupShelveListVo.orderContractStockupShelvesVos // 本地仓库
          const _dataList =
            element.orderContractStockupShelveListVo
              .orderContractStockupShelvesVoList // 调拨仓库
          const _dataListVal =
            val.orderContractStockupShelveListVo
              .orderContractStockupShelvesVoList // 调拨仓库
          _data.forEach((data, counts) => {
            data.countUsed = _dataVal[counts].countUsed
          })
          _dataList.forEach((data, counts) => {
            data.countUsed = _dataListVal[counts].countUsed
          })
          element.orderContractStockupVo.countUsedAllot += countAllot
          element.orderContractStockupVo.countUsed =
            this.allocatedList[index].orderContractStockupVo.countUsed + count
        }
      })
      this.formattingWaitList() // 待配货清单
      this.formattingUsedList() // 使用过得数组
      if (countAllot !== 0) {
        this.formattingAllotClone(countAllot, params) // 把采购计划数据放入Clone数组
        this.PlanReset(count, params) // 分情况采购计划
      }
    },
    // 以下是采购配货区方法...Julie.2020.11.13
    // 格式化采购计划
    PlanReset (count, params) {
      // debugger
      const data = this.purchaseList[0]
        .orderContractStockupVoList // 这个是采购计划的第一个计划的List
      let isFalse = false
      data.forEach((ele) => {
        if (params.ocscId === ele.ocscId) {
          isFalse = true
          // ele.count += params.count
        }
      })
      if (!isFalse) {
        data.push(params)
      }
    },
    // 撤销采购计划数据
    purchasePlan (items, indexs) {
      const data = this.purchaseList[0]
        .orderContractStockupVoList[indexs]
      this.allocatedListUsed.forEach((element) => {
        if (data.ocscId === element.orderContractStockupVo.ocscId) {
          element.orderContractStockupVo.countUsedAllot =
            element.orderContractStockupVo.countUsedAllot - data.count
        }
      })
      this.purchaseList[0].orderContractStockupVoList.splice(
        indexs,
        1
      )
      this.procurementPlanListClone[0].orderContractStockupVoList.forEach(
        (ele, ind) => {
          if (items.ocscId === ele.ocscId) {
            ele.count = ele.count - items.count
            if (ele.count === 0) {
              this.procurementPlanListClone[0].orderContractStockupVoList.splice(
                ind,
                1
              )
              ind--
            }
          }
        }
      )
      this.formattingWaitList()
    },
    // 提交备货
    onSubmitStockUp () {
      if (this.allocatedList.length !== 0) {
        this.$message.error('请完成配货！')
      } else {
        const params = {}
        params.psbId = +this.$route.query.psbId
        params.purchaseType = this.status - 1
        let local = deepClone(this.warehouseList)
        let allot = deepClone(this.purchaseList)
        if (allot.length === 1 && allot[0].orderContractStockupVoList.length === 0) {
          allot = null
        } else {
          allot.forEach((data, index) => {
            data.orderContractStockupVoList.forEach(ele => {
              ele.stockupCount = ele.count
            })
          })
        }
        if (local.length === 0) {
          local = null
        } else {
          local.forEach(ele => {
            ele.orderContractStockupShelvesVoList.forEach(data => {
              data.stockupCount = data.countUsed
            })
          })
        }
        if (allot !== null) {
          params.orderContractStockupPurchaseVoList = allot[0].orderContractStockupVoList
        } else {
          params.orderContractStockupPurchaseVoList = null
        }
        params.orderContractStockupStorageVoList = local
        addOrderContractStockupPurchase(params)
          .then((res) => {
            if (res.data.code === 200) {
              this.$router.push({ name: 'waitAllocateCargoList' })
              this.$message.success('已完成配货!')
            } else {
              this.$message.error(res.data.msg)
            }
          })
          .catch((err) => {
            console.log(err)
          })
      }
      // 最后的提交
    }
  },
  filters: {
    dateFilter
  }
}
function dateFilter (time) {
  if (time === null) {
    return ''
  } else {
    const date = new Date(time)
    return formatDate(date, 'yyyy-MM-dd hh:mm')
  }
}
</script>
<style lang="scss">
</style>
